import React , { useState, useEffect }  from "react";
//import { Link } from "react-scroll";
import { Link } from "react-router-dom";
import ReadMore from 'components/ui/Readmore';
import {LinkIcon} from 'components/icons/link-icon';
import {ArrowUp} from 'components/icons/arrow-up';
import {ArrowDown} from 'components/icons/arrow-down';
import { PlusIcon } from "@heroicons/react/solid";
import {useAuth} from 'contexts/provider/AuthProvider'
import { useNavigate } from "react-router-dom";
import {Links} from 'routes/PathLink'
import {SMEIcon} from 'components/icons/SMEIcon.tsx';
import {ArrowNext} from  'components/icons/arrow-next';
import {ChartNetwork} from  'components/icons/chart-network';
import {GlobalMarket} from  'components/icons/global_market';
import {IndustryIcon} from  'components/icons/industry-icon';
import {ChartGearIcon} from  'components/icons/chartgear-icon';
import {formatINR , getWebsiteName ,formatINRWithSYm 
  ,formatDateTime , toTitleCase } from 'components/config/Common';
import {
  useCompanyDefaultRatioData ,
  useSaveFollowMutation,
  useCompanyQueryAnalysis,
  useCompanyQuerySectorByComp,
} from 'data/company';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaBriefcase, FaUsers } from "react-icons/fa";
import { MdFollowTheSigns } from "react-icons/md";
import {useIncreaseStockView, useStockStatQuery} from 'data/stock-stat-data'
import ShareSection from 'components/ui/sharesection.tsx';
import {useCompanyFin} from "contexts/companyfindata/companyfindata.context.tsx"
import PercentChangeBox from 'components/ui/PercentChangeBox';

import TradingStatus from 'components/cards/TradingStatus';

export default function CompanyBasicSection({companyinfo,isFollowed}) {
  const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'));
  const {logout, isUser} = useAuth();
  let navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  //const [isFollowed , setIsFollowed] = useState(false);
  //const id = companyinfo?.id;
  //console.log('id====',id)
  const {setCompratiodefault, setCompratiodefloading} = useCompanyFin();
  
  const {
          technicalanalysis,
          
        } = useCompanyQueryAnalysis(companyinfo?.id);
  
  //console.log("technicalanalysis",technicalanalysis);
    
  const {
        companydefaultratio,
        isLoading: loading,
        error:errorindicescomp,
        companymainLabelsList,
      } = useCompanyDefaultRatioData(companyinfo?.id);
   const company_basic_info = JSON.parse(companyinfo?.company_basic_info);

   const {mutate:increase_count} = useIncreaseStockView();
    
   const { mutate, isLoading } = useSaveFollowMutation();

   const {data:stockStat} = useStockStatQuery({id:companyinfo?.id})

  

   //console.log('stock stat=====', stockStat)
   //useSaveFollowMutation
   
    useEffect(() => {
      // code runs whenever `type` changes
     setCompratiodefault(companydefaultratio??{});
      setCompratiodefloading(loading);
    }, [loading]);
   
    useEffect(() => {      
      updateViewCount(companyinfo?.id)
    }, [companyinfo]);

    const updateViewCount = (id) => {
      //console.log('id====>',id)
      increase_count(id)
    }

  const followStock = ()=>{
    if(isUser){
      mutate({
        id:companyinfo?.id,
      security_id: companyinfo?.id,
      action: isFollowed ? 'unfollow' : 'follow',
      access_token:access_token,
    });
    
    }else{
      navigate(`${Links.USER_LOGIN}`);
    }
  }
  const compactIN = (num) =>
    new Intl.NumberFormat('en-IN', {
      notation: 'compact',
      compactDisplay: 'short',
      maximumFractionDigits: 1,
  }).format(num);

  const performanceData = [
  { label: "1 Week", value: 'week_price_change' },
  { label: "1 Month", value: 'month_price_change' },
  { label: "6 Month", value: 'month6_price_change' },
  { label: "1 Year", value: 'month12_price_change' },
];

const entries = Object.entries(companymainLabelsList || {});
const visibleEntries = showAll ? entries : entries.slice(0, 9); // 3 rows × 3 cols

  return (
      <section className="bg-white shadow-md z-50 rounded-xl p-5" id="top-ratios">
         <div className="flex flex-col lg:flex-row py-2 px-2 gap-x-14 gap-y-4 w-full">
          <div className="w-full lg:w-2/3 gap-3 space-y-4 ">
              <div className="flex flex-wrap items-start justify-between gap-2">
               
                  <h1 className="text-heading text-[1.8rem] md:text-[2.5rem] break-words">
                    {companyinfo?.name}
                  </h1>
                
               <div className="flex-shrink-0">
                  <div className="flex gap-x-2 whitespace-nowrap items-center">
                    <div className="text-xl text-heading">{companyinfo?.nse_price?
                    formatINRWithSYm(companyinfo?.nse_price,2)
                    :
                    null
                    }                                       
                    </div>
                    <div>
                      {companyinfo?.p_change && <>
                      {companyinfo?.p_change < 0?
                        (<div className="text-red-600 flex gap-x-2 items-center"><ArrowDown className="w-2 h-2" />{companyinfo?.p_change}%</div>)
                        :
                        (<div className="text-emerald-500 flex gap-x-2 items-center"><ArrowUp className="w-2 h-2" />{companyinfo?.p_change}%</div>)
                        }
                        </>
                      }
                    </div>
                  </div>
                  <div className="text-sm" >{companyinfo?.price_updated_on?
                  formatDateTime(companyinfo?.price_updated_on)
                  :
                  null
                  }</div>

                 {companyinfo?.status && companyinfo?.status == 'temporary suspended' &&
                  <TradingStatus status={companyinfo?.status} />
                   }
                </div>
                
              </div>
             
              <div className="flex flex-col gap-y-1">
              <div className="flex flex-row itens-start md:items-center top-ratio-first-sec justify-space gap-y-2 gap-x-6 flex-wrap ">
                {companyinfo?.exchange != 'bse' &&<div className="font-normal text-gray-600">NSE: {companyinfo?.symbol} 
                </div>}
                <div className="font-normal text-gray-600">BSE: {companyinfo?.bse_code ? companyinfo?.bse_code : '-' } {companyinfo?.exchange == 'bse' && <>{companyinfo?.symbol}</>  }</div>
                {companyinfo.is_sme == 1 &&<div>
                  <div className="flex w-fit border-[1px] border-accent p-1 rounded items-center gap-x-2">
                    <SMEIcon className="w-4 h-4" color="#18CB96"/> SME</div>
                </div>}
                <div className="top-ratio-first-sec">
                  {company_basic_info?.website ?
                  <div className="flex gap-1 items-center">
                    <a
                    href={company_basic_info?.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-accent flex gap-1 items-center"
                  >
                    <LinkIcon className="w-6 h-6" fill="#18CB96" color="#18CB96"/>
                    {getWebsiteName(company_basic_info?.website)}
                  </a>
                  </div>
                  : companyinfo?.website_link ?
                  (<div>
                    <a
                    href={companyinfo?.website_link}
                    className="text-accent flex gap-1 items-center"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkIcon className="w-6 h-6" fill="#18CB96" color="#18CB96"/>
                    {getWebsiteName(companyinfo?.website_link)}
                  </a>
                  </div>)
                  :null
                  }
                  </div>
                <div></div>
              </div>

           
                </div>


{entries.length === 0 ? null : (
  <div className="border-[1px] border-gray-300 rounded-xl px-4 py-6">
    
    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-3">
      {visibleEntries.map(([key, item], index) => {
        const rowIndex = Math.floor(index / 3);

        return (
          <div
            key={index}
            className={`p-3 border-b-[1px] md:border-0 rounded flex justify-between items-center 
            ${rowIndex % 2 === 0 ? "bg-white" : "bg-white md:bg-gray-50"}`}
          >
            <div className="text-[0.95rem] text-gray-600">{key}</div>
            <div>
              <span>{item?.prefix}</span>
              <span className="text-sm numbercss">
                {item?.is_format
                  ? formatINR(item?.value, 2)
                  : item?.value}
              </span>
              <span className="text-gray-500 text-sm">
                {item?.postfix}
              </span>
            </div>
          </div>
        );
      })}
    </div>

    {/* 👇 Button INSIDE box */}
    {entries.length > 9 && (
      <div className="flex justify-end pt-3 md:border-t mt-4">
        <button
          onClick={() => setShowAll(!showAll)}
          className="text-accent text-sm font-medium hover:underline"
        >
          {showAll ? "Show Less" : "Show More"}
        </button>
      </div>
    )}
  </div>
)}
          </div>
          <div className="w-full lg:w-1/3  flex flex-1 flex-col company-profile">
             <div className="flex flex-row flex-wrap lg:flex-nowrap pb-6 gap-2 items-center mt-5 lg:mt-0">
                  {stockStat?.data?.viewCount ?
                  <button data-tooltip-id="view-tooltip" type="button" className="flex items-center gap-1 border border-accent py-1 px-3 rounded text-accent"
                  data-tooltip-html="<div class='w-48'>It shows how many times users have viewed the details about this company.</div>">
                    <FaUsers />
                    <div className="text-gray-600">{compactIN(stockStat?.data?.viewCount)}</div>
                  </button>
                  :null
                  }
                  {stockStat?.data?.followCount ?
                  <button data-tooltip-id="view-tooltip" type="button" className="flex items-center gap-1 border border-accent text-accent py-1 px-3 rounded"
                  data-tooltip-html="<div class='w-48'>It shows how many people are following this stock to track its performance.</div>">
                    <MdFollowTheSigns />
                    <div className="text-gray-600">{compactIN(stockStat?.data?.followCount)}</div>
                  </button>
                  :null
                  }
                  {stockStat?.data?.portfolioCount ?
                  <button data-tooltip-id="view-tooltip" type="button" className="flex items-center gap-1 border border-accent text-accent py-1 px-3 rounded"
                  data-tooltip-html="<div class='w-48'>It shows how many people have added this stock in their smart portfolio.</div>">
                    <FaBriefcase />
                    <div className="text-gray-600">{compactIN(stockStat?.data?.portfolioCount)}</div>
                  </button>
                  :null
                  }
                  <button type="button" onClick={followStock} class={`${isFollowed? "bg-gray-100  " : " bg-accent text-white "} text-heading  uppercase font-2xl font-semibold bg-accent box-border border border-transparent hover:bg-acent-strong  shadow-xs font-medium leading-5 rounded text-sm px-2 py-1.5 focus:outline-none flex gap-x-1 items-center`} > 
                    <PlusIcon className={`w-4 h-4 ${isFollowed ? '' : ' text-white '} text-body`} /> 
                    <div>Follow</div>
                  </button>
             </div>
             <div>
              <ReactTooltip
                id="view-tooltip"
                place="top"                
                style={{zIndex:99}}
              />
             </div>
             <div>
              <div className="h-0 md:h-10">
                {/*<ShareSection title={`${companyinfo?.name} Stock Analysis & Financial Data`} />*/}
              </div>

               <h2 className="title text-heading py-2 ">Price Trend</h2>
            <>{technicalanalysis?.week_price_change != null &&
              technicalanalysis?.month_price_change != null &&
              technicalanalysis?.month6_price_change != null &&
              technicalanalysis?.month12_price_change != null
                            ?
                    <div className="flex items-center justify-center w-full bg-white shadow-lg rounded-xl p-5 border lg:h-[150px]">
                    <div className="flex gap-x-6 gap-y-4 justify-center lg:justify-start flex-wrap">
                    {performanceData.map((item) => (
                      <div key={item.label}>
                        <p className="text-sm mb-1 text-gray-500 text-center">{item.label}</p>
                        <PercentChangeBox value={technicalanalysis[item.value]} />
                      </div>
                    ))}
                  </div>
                  </div>
                  :
                  <p className="pb-10 text-center">Not data available yet.</p>
              }</>
              {/*companyinfo?.about &&
              <>
              <h4 className="title text-heading py-2 ">About</h4>
              <p className="text-base text-gray-600">
                <ReadMore
                text={companyinfo?.about}
                limit={240}
                companyinfo={companyinfo}
                />
                </p>
                </>
                */}
            </div>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row py-5 px-2 gap-10 w-full justify-between items-start text-black">
          <div className="w-full lg:w-1/2">
           
          </div>
          <div className="w-full lg:w-1/2">
             
            
          </div>
        </div>
         {/*<div className="flex gap-x-2 items-center pt-10">
           <div className="text-sm italic text-gray-600"> * Above Market Cap, P/E Ratio, P/B Ratio, Book Value  calculated using previous day nse price.
            </div>
        </div>*/}
      </section> 
  );
}
